import { LocationDto } from 'entities/Location';

import {
  ORDER_ADD_BLLIST_REQUEST,
  ORDER_ADD_BLLIST_SUCCESS,
  ORDER_ADD_BLLIST_ERROR,
  GET_LOCATION_REQUEST,
  GET_LOCATION_SUCCESS,
  GET_LOCATION_ERROR,
  ADD_USER_ID_REQUEST,
  ADD_USER_ID_SUCCESS,
  ADD_USER_ID_ERROR,
  ORDER_CLEAN_ERROR,
  ORDER_GET_USER_ID_REQUEST,
  ORDER_GET_USER_ID_SUCCESS,
  ORDER_GET_USER_ID_ERROR,
} from './constants';

export const cleanErr = () => ({
  type: ORDER_CLEAN_ERROR,
});

export const addBLListReguest = (data: any) => ({
  type: ORDER_ADD_BLLIST_REQUEST,
  payload: data,
});

export const addBLListSuccess = () => ({
  type: ORDER_ADD_BLLIST_SUCCESS,
});

export const addBLListError = (error: Error | null) => ({
  type: ORDER_ADD_BLLIST_ERROR,
  payload: error,
});

export const getLocationReguest = () => ({
  type: GET_LOCATION_REQUEST,
});

export const getLocationSuccess = (data: LocationDto[]) => ({
  type: GET_LOCATION_SUCCESS,
  payload: data,
});

export const getLocationError = (error: Error | null) => ({
  type: GET_LOCATION_ERROR,
  payload: error,
});

export const orderGetDrIdReguest = (id: number, tripValue: any, field: string) => ({
  type: ORDER_GET_USER_ID_REQUEST,
  payload: id,
  tripValue,
  field,
});

export const orderGetDrIdSuccess = (id: string) => ({
  type: ORDER_GET_USER_ID_SUCCESS,
  payload: id,
});

export const orderGetDrIdError = (error: Error | null) => ({
  type: ORDER_GET_USER_ID_ERROR,
  payload: error,
});

export const addUserIDReguest = (id: number, field: string, value: any) => ({
  type: ADD_USER_ID_REQUEST,
  payload: id,
  field,
  value,
});

export const addUserIDSuccess = () => ({
  type: ADD_USER_ID_SUCCESS,
});

export const addUserIDError = (error: Error | null) => ({
  type: ADD_USER_ID_ERROR,
  payload: error,
});

export type Actions =
  | ReturnType<typeof orderGetDrIdReguest>
  | ReturnType<typeof orderGetDrIdSuccess>
  | ReturnType<typeof orderGetDrIdError>
  | ReturnType<typeof getLocationReguest>
  | ReturnType<typeof getLocationSuccess>
  | ReturnType<typeof getLocationError>
  | ReturnType<typeof addBLListReguest>
  | ReturnType<typeof addBLListSuccess>
  | ReturnType<typeof addBLListError>
  | ReturnType<typeof addUserIDReguest>
  | ReturnType<typeof addUserIDSuccess>
  | ReturnType<typeof addUserIDError>
  | ReturnType<typeof cleanErr>;
